import { Container, Button, ButtonGroup } from 'reactstrap';
import { useForm } from "react-hook-form"
import axios from 'axios';
import useToken from '../../useToken';
import { useGetCategorieQuery } from '../../../features/CallApi';
import { useParams, useNavigate } from 'react-router-dom';
import LoadScreen from '../../UI/LoadScreen';


export const CategoriesEdit = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const { register, handleSubmit, formState: { errors }, reset } = useForm();
    const { isLoading, data, refetch, error, isFetching } = useGetCategorieQuery(id);
    const { token } = useToken();

    const putCategories = async (data) => {
        const response = await axios.put(`/api/categories/${id}`, data, {
            headers: {
                'Content-type': 'application/json; charset=UTF-8',
                Authorization: "Bearer " + token
            }
        })

        if (response.status >= 200 || response.status <= 204) {
            console.log(data)
            refetch()
            navigate('/admin/categories')
            // console.log(response.data)
        }
    }

    return (
        <Container>
            <div>
                {isLoading ? <LoadScreen /> :
                    <div>
                        {error ? <div>
                            <h2>{error.status}</h2>
                            <p>{error.data.title}</p>
                        </div> : <div>
                            {data && data.length > 0 ? <h1>{error}</h1> :
                                <form onSubmit={handleSubmit(putCategories)} key={data.id}>
                                    <div className="mb-3">
                                        <input hidden value={data.id} {...register("id", {})} />
                                        <label htmlFor="name" className="form-label">Название</label>
                                        <input id="name" name="name" placeholder="Укажите Название" defaultValue={data.name} type="string" className="form-control"
                                            {...register("name", {
                                                required: { value: true, message: "Поле \"Название\" не может быть пустым" }
                                            })} />
                                        {errors.name && <span className='text-danger'>{errors.name?.message}</span>}
                                    </div>
                                    <ButtonGroup>
                                        <Button color="success">
                                            Сохранить
                                        </Button>
                                        <Button color="warning" onClick={() => navigate(`/admin/categorie`)}>
                                            Отмена
                                        </Button>
                                    </ButtonGroup>
                                </form>
                            }
                        </div>
                        }
                    </div>
                }
            </div>
        </Container>
    )

}